module.exports = __webpack_public_path__ + "img/back02.c0331513.jpg";